import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberWorkingExperience } from "./routeType";

const { key, getPath } = getApi("members.workingExperience.getAll");

type IExtractedRouteType =
  IMemberWorkingExperience["workingExperienceCollectionRetrieve"];

export type IGetAllMemberWorkingExperiences =
  IPickCollectionQuery<IExtractedRouteType>;

const getAllMemberWorkingExperiences: Fetcher<
  IGetAllMemberWorkingExperiences["response"],
  IGetAllMemberWorkingExperiences["variables"]
> = ({ memberId, ...params }) => {
  return axiosClient.get(getPath({ memberId }), { params });
};

export const useGetAllMemberWorkingExperiences = createQuery({
  queryKey: [key],
  fetcher: getAllMemberWorkingExperiences,
});
